import { section } from "@/neon";

section("image-with-text", {
  onLoad() {},
  onUnload() {},
});
